import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { analytics } from '../../services/analytics';
import SEOPageLayout from '../../components/SEOPageLayout';

const PestControlPackages = () => {
  useEffect(() => {
    analytics.track('Template Page View', { template: 'Pest Control Quote Template' });
  }, []);

  return (
    <SEOPageLayout
      title="Free Pest Control Quote Template - Tiered Options (Good/Better/Best) | QuoteTier"
      description="Free pest control quote template with Good/Better/Best service tiers. Convert one-time emergency calls into quarterly recurring contracts."
      canonical="/templates/pest-control-packages-template"
      ogTitle="Free Pest Control Quote Template"
      ogDescription="One-time pest calls are commodity work. Quarterly contracts are recurring revenue. The template is how you move customers from one to the other."
    >
      <section className="py-32 md:py-40 lg:py-48">
        <div className="container max-w-7xl mx-auto px-4">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="font-instrument text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tight leading-tight mb-6">
              Free <span className="text-primary font-bold">Pest Control Quote Template</span>
            </h1>
            <p className="font-jetbrains text-xl md:text-2xl text-gray-600 tracking-tight leading-relaxed mb-8">
              Turn one-time emergency calls into quarterly recurring contracts by showing the recurring option in the same quote.
            </p>
            <div className="max-w-2xl mx-auto mb-10 p-5 border border-gray-200 rounded-lg bg-gray-50 text-left">
              <p className="font-jetbrains text-sm md:text-base text-gray-700 leading-relaxed">
                A one-time pest treatment is commodity work at commodity margins. A quarterly service plan is recurring revenue with a predictable route. Showing both on the same quote is the easiest conversion path — customers who want the emergency fix often take the plan too once they see the maths.
              </p>
            </div>
            <div className="font-instrument mt-8 flex flex-col sm:flex-row gap-6 justify-center items-center mb-3">
              <Link to="/signup">
                <Button className="px-8 py-4 text-xl font-semibold bg-black text-white hover:bg-gray-800 rounded-lg shadow-lg">
                  Use This Template Free
                </Button>
              </Link>
            </div>
            <p className="font-jetbrains text-sm text-gray-500 mb-6">Free account — no credit card required.</p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-gray-50">
        <div className="container max-w-6xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="font-instrument text-3xl md:text-4xl font-bold mb-4">Sample Tiers</h2>
          </div>

          <div className="grid gap-6 md:grid-cols-3">
            <Card className="border border-black">
              <CardHeader><CardTitle className="font-instrument text-xl">One-Time</CardTitle><CardDescription>The Budget Option</CardDescription></CardHeader>
              <CardContent>
                  <ul className="font-jetbrains text-sm text-gray-600 list-disc list-inside">
                      <li>Single treatment visit</li>
                      <li>Targeted pest removal</li>
                      <li>30-day re-treat guarantee</li>
                  </ul>
              </CardContent>
            </Card>
            <Card className="border border-black bg-black text-white">
              <CardHeader><CardTitle className="font-instrument text-xl text-white">Quarterly Shield</CardTitle><CardDescription className="text-gray-300">Best Seller</CardDescription></CardHeader>
              <CardContent>
                  <ul className="font-jetbrains text-sm text-gray-300 list-disc list-inside">
                      <li>4 seasonal treatments/year</li>
                      <li>Perimeter barrier spray</li>
                      <li>Interior spot treatments</li>
                      <li>Free emergency callbacks</li>
                  </ul>
              </CardContent>
            </Card>
            <Card className="border border-black">
              <CardHeader><CardTitle className="font-instrument text-xl">Premium Shield</CardTitle><CardDescription>Total Coverage</CardDescription></CardHeader>
              <CardContent>
                  <ul className="font-jetbrains text-sm text-gray-600 list-disc list-inside">
                      <li>Monthly treatments</li>
                      <li>Everything in Quarterly</li>
                      <li>Rodent monitoring stations</li>
                      <li>Mosquito & tick yard spray</li>
                  </ul>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-black text-white">
        <div className="container max-w-4xl mx-auto px-4 text-center">
          <h2 className="font-instrument text-3xl md:text-4xl font-bold mb-6">Start Using This Template Now</h2>
          <Link to="/signup">
            <Button className="px-10 py-4 font-instrument text-xl font-semibold bg-white text-black hover:bg-gray-200 rounded-lg shadow-lg">
              Get Free Access
            </Button>
          </Link>
        </div>
      </section>
    </SEOPageLayout>
  );
};

export default PestControlPackages;
